"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var div = document.createElement("div");
    div.className = "notification ".concat(type);
    div.style.top = "".concat(posTop, "px");
    div.style.right = "".concat(posRight, "px");
    var titleEL = document.createElement("h2");
    titleEL.className = "title";
    titleEL.textContent = title;
    var paragraph = document.createElement("p");
    paragraph.textContent = description;
    div.appendChild(titleEL);
    div.appendChild(paragraph);
    document.body.appendChild(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.2263f3b4.js.map
